import { schemes } from "@zeal/common";
import { z } from "zod";

export const EPaymentType = {
  CARD: "card",
  BANK: "bank",
} as const;

export type EPaymentType = (typeof EPaymentType)[keyof typeof EPaymentType];

export const submitInvoicePaymentSchema = z.object({
  type: z.nativeEnum(EPaymentType),
  paymentInstrumentID: schemes.uuid(),
  invoiceID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  companyID: schemes.uuid(),
});

export type TSubmitInvoicePaymentRequest = z.infer<
  typeof submitInvoicePaymentSchema
>;
